import React, {memo, useCallback, useRef} from 'react';
import {
  ErrorMessage, Field, Form, Formik,
} from 'formik';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import * as Yup from 'yup';
import {t} from '../../../../services/i18nHandler';
import './ModalInfoForm.less';
import Modal from '../../index';
import CommonAPI from '../../../../api/common';
import {NotificationError, NotificationSuccess} from '../../../../services/notifications';
import {CloseIcon} from '../../../SvgComponents/SvgComponents';

const initialValues = {
  name: '',
  surname: '',
  company: '',
  email: '',
  phone: '',
};

const validationSchema = Yup.object().shape({
  name: Yup.string()
    .max(30, 'Максимальная длина имя 30 символов')
    .required('Поле обязательно к заполнению'),
  surname: Yup.string()
    .max(30, 'Максимальная длина фамилии 30 символов')
    .required('validation.isRequired'),
  company: Yup.string()
    .max(100, 'Максимальная длина 100 символов')
    .required('validation.isRequired'),
  email: Yup.string()
    .email('validation.notValidEmail')
    .max(60, 'Максимальная длина email 60 символов')
    .required('validation.isRequired'),
  phone: Yup.string()
    .min(12, 'Минимальная длина номера 6 символов')
    .max(24, 'Максимальная длина номера 24 символов')
    .required('validation.isRequired'),
});

function ModalInfoForm({isOpen, onClose}) {
  const formRef = useRef();

  const onSubmit = useCallback(async (values) => {
    await CommonAPI.employerSubscribeToNews(values).then(() => {
      NotificationSuccess('Форма успешно отправлена');
      onClose();
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    });
  }, [onClose]);

  return (
    <Modal className="modal-center modal-info-form" isOpen={isOpen} onHide={onClose}>
      <div className="modal-inner">
        <div className="modal-container">
          <div className="modal-content" style={{position: 'relative'}}>
            <button
              type="button"
              className="modal-close-btn"
              style={{position: 'absolute', top: 10, right: 10}}
              onClick={onClose}
            >
              <CloseIcon />
            </button>
            <div className="modal-info-form_title">
              {t('aboutPlatformModalForm.modalTitle')}
            </div>
            <div className="modal-info-form_text">
              {t('aboutPlatformModalForm.modalText')}
            </div>
            <Formik
              ref={formRef}
              onSubmit={onSubmit}
              initialValues={initialValues}
              validationSchema={validationSchema}
            >
              <Form>
                <div className="modal-info-form_field">
                  <div className="modal-info-form_field_label">
                    {t('inputs.name')}
                  </div>
                  <Field
                    type="text"
                    name="name"
                    className="ui-input"
                    placeholder={t('placeholders.name')}
                  />
                  <ErrorMessage
                    className="error-text"
                    name="name"
                    component="div"
                  >
                    {(msg) => (<div className="error-text">{t(msg)}</div>)}
                  </ErrorMessage>
                </div>
                <div className="modal-info-form_field">
                  <div className="modal-info-form_field_label">
                    {t('inputs.surname')}
                  </div>
                  <Field
                    type="text"
                    name="surname"
                    className="ui-input"
                    placeholder={t('placeholders.surname')}
                  />
                  <ErrorMessage
                    className="error-text"
                    name="surname"
                    component="div"
                  >
                    {(msg) => (<div className="error-text">{t(msg)}</div>)}
                  </ErrorMessage>
                </div>
                <div className="modal-info-form_field">
                  <div className="modal-info-form_field_label">
                    {t('inputs.companyName')}
                  </div>
                  <Field
                    type="text"
                    name="company"
                    className="ui-input"
                    placeholder={t('placeholders.companyName')}
                  />
                  <ErrorMessage
                    className="error-text"
                    name="company"
                    component="div"
                  >
                    {(msg) => (<div className="error-text">{t(msg)}</div>)}
                  </ErrorMessage>
                </div>
                <div className="modal-info-form_field">
                  <div className="modal-info-form_field_label">
                    {t('inputs.email2')}
                  </div>
                  <Field
                    type="text"
                    name="email"
                    className="ui-input"
                    placeholder={t('placeholders.email')}
                  />
                  <ErrorMessage
                    className="error-text"
                    name="email"
                    component="div"
                  >
                    {(msg) => (<div className="error-text">{t(msg)}</div>)}
                  </ErrorMessage>
                </div>
                <div className="modal-info-form_field">
                  <div className="modal-info-form_field_label">
                    {t('inputs.phoneNumber')}
                  </div>
                  <Field
                    name="phone"
                    render={({field, form}) => (
                      <NumberFormat
                        value={field.value}
                        format="+# (###) ###-##-########"
                        mask=""
                        placeholder="+7 (XXX) XXX-XX-XX"
                        className="ui-input"
                        onChange={(e) => {
                          form.setFieldValue('phone', e.target.value);
                        }}
                      />
                    )}
                  />
                  <ErrorMessage
                    className="error-text"
                    name="phone"
                    component="div"
                  >
                    {(msg) => (<div className="error-text">{t(msg)}</div>)}
                  </ErrorMessage>
                </div>
                <div className="btn-wrap">
                  <button type="submit" className="btn btn-base">
                    {t('buttons.sent')}
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ModalInfoForm.defaultProps = {};

ModalInfoForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default memo(ModalInfoForm);
